import { render, staticRenderFns } from "./CopyStakeAiStreamersTabsView.vue?vue&type=template&id=3ec91bfa&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamersTabsView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamersTabsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec91bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabsItems})
